import { LinearProgress } from '@material-ui/core'
import { FC, Fragment } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { CloseDialog } from '../../../actions/types'
import { DialogButtons, SubmitFormButton } from '../../../components/Buttons'
import ErrorMessage from '../../../components/Error/ErrorMessage'

import { ReduxForm } from '../../../types/forms'

interface EditShowingFormrops extends WithTranslation, ReduxForm {
  closeDialog: CloseDialog
  editShowingAction: () => void
}

/** if isConfirmDialog, just show the form submit button */
const EditShowingForm: FC<EditShowingFormrops> = ({
  handleSubmit,
  submitting,
  error,
  closeDialog,
  editShowingAction
}) => (
  <form onSubmit={handleSubmit(editShowingAction)}>
    <Fragment>
      <ErrorMessage error={error} />
      {submitting && <LinearProgress />}
      <DialogButtons
        closeDialog={closeDialog}
        dialogName='ShowingsConfirmationEditDialog'
        ButtonTwo={
          <SubmitFormButton
            textColor='white'
            variant='contained'
            submitting={submitting}
            label='application.inviteApplicants'
          />
        }
      />
    </Fragment>
  </form>
)

export default connect()(
  reduxForm({
    form: 'EditShowingsForm',
    keepDirtyOnReinitialize: true,
    destroyOnUnmount: false
  })(withTranslation()(EditShowingForm) as any) as any
) as any
